import { Component, OnInit, OnChanges, Output, Input, EventEmitter, SimpleChanges } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { AutoRoutingService, IDriver } from '../../../../services/auto-routing.service';
import { AutoroutingService } from '../../../autorouting/autorouting.service';

@Component({
  selector: 'app-auto-routing-drivers',
  templateUrl: './auto-routing-drivers.component.html',
  styleUrls: ['./auto-routing-drivers.component.scss']
})
export class AutoRoutingDriversComponent implements OnInit, OnChanges {

  gridDrivers: GridOptions;
  codesSelected:  Array<IDriver> = [];
  numMaxSelecte = 5;
  private start = false;

  @Output() onCodesSelected?: EventEmitter <any> = new EventEmitter <any>();
  @Output() scheduleid?: EventEmitter<any> = new EventEmitter<any>();
  @Output() showUnassignedMap?: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() jobId?: number;
  @Input() driver?: any[];
  @Input() activeExport = false;

  constructor(
    private _autoRoutingService: AutoRoutingService,
    private _autoRoutingJobService:AutoroutingService,
    private toastrAlertHelper: ToastrAlertHelper,
    private sweetAlertHelper: SweetAlertHelper,
  ) {
    this.gridDrivers = <GridOptions>{};
    this.gridDrivers.columnDefs = this.createDef();
    this.gridDrivers.getRowNodeId = (data) => {
      return data.scheduleid;
    }
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['driver']) {
      if( this.driver && this.gridDrivers.api) {

        if (!this.start) {
          this.gridDrivers.api.setRowData(this.driver);
          this.setSelectedUnassigned();
          this.start = true;
        } else {
          const tem = this.gridDrivers.api.getSelectedNodes();
          this.gridDrivers.api.setRowData(this.driver);
          tem.forEach((row) => {
            this.gridDrivers.api.forEachNode(function (node) {
              if (row.data.code === node.data.code) {
                node.setSelected(true);
              }
            });
          });
        }
      }
    }
  }


  onGridReady() {
    this.gridDrivers.api.setRowData(this.driver);
  }

  createDef() {

    return  [
      { headerName: '', checkboxSelection: true, width: 20 },
      { headerName: 'Code', field: 'code', colId: 'code', width: 60 },
      { headerName: 'Provider', field: 'speedcode', colId: 'speedcode', width: 60 },
      { headerName: 'Driver', field: 'driver', colId: 'driver', width: 120 },
      { headerName: 'Count', field: 'count', colId: 'count', width: 40 },
      { headerName: '', field: 'drivercolor', colId: 'drivercolor', width: 30, cellStyle: (params) => {
          return {
            color: `${params.value}`, backgroundColor: `${params.value}`
          }
        } },
      { headerName: 'Hasintegration', field: 'hasintegration', colId: 'hasintegration', hide: true },

    ];
  }

  onSelectionChanged(event) {
    const selectedRows = this.gridDrivers.api.getSelectedRows();
    if(selectedRows.length <= this.numMaxSelecte) {
      this.codesSelected = [];
      selectedRows.forEach((selectedRow, index) => {
        this.codesSelected.push(selectedRow);
      });
      this.onCodesSelected.emit(this.codesSelected);
    } else {
      /*this.gridDrivers.api.forEachNodeAfterFilter( function(node) {
         node.setSelected(false);
      });*/
      // toastr.warning('You can only select 5 drivers at the same time...');
    }
  }

  onRowSelected(event) {
    const selectedRows = this.gridDrivers.api.getSelectedRows();
    if(selectedRows.length <= this.numMaxSelecte) {
      if (event.node.data.scheduleid === undefined) {
        this.showUnassignedMap.emit(event.node.isSelected());
      } else {
        if (!event.node.isSelected()) {
          this.scheduleid.emit(event.node.data.scheduleid);
        }
      }
    } else {
      event.node.setSelected(false);
      this.toastrAlertHelper.warning('You can only select 5 drivers at the same time...');
    }
  }

  selectDriver(scheduleid) {
    const selectedRows = this.gridDrivers.api.getSelectedRows();
    const node = this.gridDrivers.api.getRowNode(scheduleid);
    node.setSelected(true);
    if(selectedRows.length <= this.numMaxSelecte) {
      this.scheduleid.emit(scheduleid);
    }
  }

  // TODO Se requiere optimizar el siguiente metodo...
  setSelectedUnassigned() {
    this.gridDrivers.api.forEachNode((node)	 => {
      if(node.data.driver === 'Unassigned') {
        node.setSelected(true);
      }
    });
  }

  exportToExcel(){
    this._autoRoutingJobService
      .getAutoroutingExport(this.jobId)
      .subscribe(
        success => {
          const blob = success.blob();
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = downloadUrl;
          a.download = 'Autorouting'+this.jobId+'.xlsx';
          document.body.appendChild(a);
          a.click();
        }
      );

  }

  clearSelected() {
    this.gridDrivers.api.deselectAll();
  }
  approveJob() {

    const approve = (result) => {
      if (result.value) {
        const data = {
          autoroutingjobid: this.jobId,
          scheduleids: this.getSelectedSchedules()
        }
        this._autoRoutingService.approbeJob(data).subscribe(
          (resp) =>
            this.sweetAlertHelper.createCustomAlert({
              title: 'Information',
              type: 'success',
              text: 'Job has been approved'
            }),
          (error) =>  this.sweetAlertHelper.createCustomAlert({
            text: error.message +
            ', Please wait to finish and try again!',
            type: 'error'
          }));
      }
    }

    if (this.getSelectedSchedules().length === 0) {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Are you sure?',
        text: 'All routes will be approved!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Approve this!'
      }).then((result) => {
        approve(result);
      });
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Are you sure?',
        text: 'Only selected routes will be approved!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Approve this!'
      }).then((result) => {
        approve(result);
      });
    }


  }

  private getSelectedSchedules() {
    const scheduleids = [];
    this.gridDrivers.api.forEachNodeAfterFilter((node) => {
      if (node.isSelected()) {
        scheduleids.push(node.data.scheduleid);
      }
    });
    return scheduleids;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/auto-routing-results/components/auto-routing-drivers/auto-routing-drivers.component.ts